/** Shared quick-action routes and keyboard shortcuts for the dashboard. */
export const DASHBOARD_QUICK_ACTIONS = [
  { label: 'New Sale', shortcut: 'F1', key: 'F1', path: '/sales/pos-keyboard' },
  { label: 'Purchase Entry', shortcut: 'F2', key: 'F2', path: '/purchases/po-keyboard' },
  { label: 'Add Product', shortcut: 'F3', key: 'F3', path: '/inventory/products' },
  { label: 'Stock Check', shortcut: 'F4', key: 'F4', path: '/reports/stock' },
  { label: 'Customer Dues', shortcut: 'F5', key: 'F5', path: '/reports/credit-customers' },
  { label: 'Sales Report', shortcut: 'F6', key: 'F6', path: '/reports/location-sales' },
  { label: 'Invoice P&L', shortcut: 'F7', key: 'F7', path: '/reports/invoice-profit-loss' },
];
